import { useQuery } from '@tanstack/vue-query';
import { debounce } from 'lodash';
import { ref, Ref, watch } from 'vue';

import financingFlow from '~/services/financing-flow-api/financing-flow';
import objectUtils from '~/utils/objects';

export interface UseFinancingsParams {
  customer_document?: string;
  customer_name?: string;
  financing_id?: number;
  is_battery?: boolean | null;
  is_combo?: boolean | null;
  page?: string;
  page_size: number;
  partner_document?: string;
  partner_id?: number;
  person_type?: string;
  project_id?: string;
  reassessment?: boolean | null;
  responsible_id?: number;
  responsible_name?: string;
  statuses?: string;
  steps?: string;
}

export default function useFinancings(params: Ref<UseFinancingsParams>) {
  const queryKey = ref(['financings', objectUtils.objectParamsToString(params.value)]);

  const queryFn = async () => {
    const res = await financingFlow.financings.listPaginate({ ...params.value });
    return res;
  };

  const query = useQuery({
    queryFn,
    queryKey,
  });

  const debouncedUpdateQueryKey = debounce((newParams) => {
    queryKey.value = ['financings', objectUtils.objectParamsToString(newParams)];
  }, 300);

  watch(
    () => params.value,
    (newParams) => {
      debouncedUpdateQueryKey(newParams);
    },
  );

  return query;
}
